(function () {

  /* =========================================================
     FABX CORPORATE QUOTE — OPERATIONAL SETTINGS
     ========================================================= */

  /*
  Rush is offered only when FABX and supplier capacity allow.
  Turn this false whenever Rush is unavailable.
  */
  var FABX_RUSH_AVAILABLE = true;


  /*
  Production Release → client in-hand planning windows.

  STANDARD
  Shrelo production: 12–14 working days
  + import / FABX handoff allowance
  = 16-working-day planning window

  RUSH
  Shrelo production: 8–10 working days
  + import / FABX handoff allowance
  = 12-working-day planning window
  */
  var STANDARD_TO_INHAND_WD = 16;
  var RUSH_TO_INHAND_WD = 12;

  var STANDARD_PRODUCTION = '12–14 working days';
  var RUSH_PRODUCTION = '8–10 working days';


  /*
  CLIENT APPROVAL SAMPLE

  Supplier production:
  approximately 5–8 working days.

  Public/client-facing allowance:
  up to 10 working days from Sample Release
  to sample in-hand.

  After sample receipt:
  minimum 3 working days are reserved for
  client / end-client review, approval and final lock.

  Only after that can Production Release occur.
  */
  var SAMPLE_PRODUCTION = '5–8 working days';
  var PHYSICAL_SAMPLE_STAGE_WD = 10;
  var CLIENT_SAMPLE_APPROVAL_WD = 3;


  /*
  Same-day Production Release cutoff.

  If everything is not ready for release before 2 PM SGT,
  the earliest Production Release planning start moves to
  the next working day.
  */
  var SAME_DAY_RELEASE_CUTOFF_HOUR_SGT = 14;
  var SAME_DAY_RELEASE_CUTOFF_MINUTE_SGT = 0;


  /*
  Bespoke planning guides.
  */
  var BESPOKE_PLANNING_STANDARD =
    'at least 4–6 weeks';

  var BESPOKE_PLANNING_COMPLEX =
    '6–8 weeks or more';


  /*
  Singapore public holidays / FABX blackout dates.

  Add supplier shutdowns or FABX closure dates when known.
  */
  var FABX_BLACKOUT_DATES = [

    '2026-01-01',
    '2026-02-17',
    '2026-02-18',
    '2026-04-03',
    '2026-05-01',
    '2026-05-27',
    '2026-06-01',
    '2026-08-10',
    '2026-11-09',
    '2026-12-25',

    '2027-01-01',
    '2027-02-08',
    '2027-03-10',
    '2027-03-26',
    '2027-05-17',
    '2027-05-20',
    '2027-08-09',
    '2027-10-28'

  ];


  /* =========================================================
     STANDARD FABX FORMATS
     ========================================================= */

  var STANDARD_FORMATS = {

    'Scarf / Carré': [

      'Scarf 30 — 30 × 30 cm',
      'Scarf 45 — 45 × 45 cm',
      'Scarf 50 — 50 × 50 cm',
      'Scarf 55 — 55 × 55 cm',
      'Scarf 70 — 70 × 70 cm',
      'Scarf 90 — 90 × 90 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Twilly / Bag Charm': [

      'Twilly — 5 × 95 cm',
      'Twilly Scarf — 10 × 120 cm',
      'Twilly Bag Charm — 5 × 45 cm',
      'Scarf Bag Charm — 30 × 30 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Furoshiki / Reusable Gift Wrap Cloth': [

      'Petite Wrap — 45 × 45 cm',
      'Wine Wrap — 70 × 70 cm',
      'Hamper Wrap — 100 × 100 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Pocket Square': [

      'Pocket Square — 35 × 35 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Fabric Bookmark / Small Textile Keepsake': [

      'Fabric Bookmark — 5 × 15 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Coaster / Tray / Desk & Table Gift': [

      'Keepsake Coaster — 10 × 10 cm',
      'Signature Coaster Set — 4 pcs',
      'Petite Coaster Tray Set',
      'Petite Valet Tray — 18 × 18 cm',
      'Heritage Valet Tray — 25 × 25 cm',
      'Other / Custom Format — Bespoke'

    ],


    'Napkin / Placemat / Dining Gift': [

      'Cocktail Napkin — 35 × 35 cm',
      'Dining Napkin — 45 × 45 cm',
      'Placemat — 45 × 35 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Table Runner / Event Table Styling': [

      'Linear Runner — 35 × 200 cm',
      'Heritage Runner — 35 × 200 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Pouch / Bag / Utility Textile Gift': [

      'Petite Drawstring — 20 × 25 cm',
      'Essential Drawstring — 25 × 30 cm',
      'Grand Drawstring — 30 × 40 cm',
      'Sommelier Drawstring — 16 × 38 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Cushion Cover': [

      'Petite Lumbar — 30 × 50 cm',
      'Grand Lumbar — 40 × 65 cm',
      'Classic Throw — 40 × 40 cm',
      'Grand Throw — 50 × 50 cm',
      'Other / Custom Size — Bespoke'

    ],


    'Printed Fabric Only — No Sewing': [

      'Printed Fabric — Size / panel to be reviewed'

    ],


    'Custom Sewn Textile Product': [

      'Custom / Bespoke Product'

    ],


    'Gift Set / Multiple Items': [

      'Custom / Bespoke Gift Set'

    ],


    'Others': [

      'Other / Bespoke Review'

    ]

  };


  /* =========================================================
     CURRENT FABX FABRICS
     ========================================================= */

  var FABRIC_GROUPS = {

    scarves: [

      {
        label: 'Signature Fabrics',

        fabrics: [
          'Chiffon',
          'Chiffon Silk Doff',
          'Satin Cavalli',
          'Satin Velvet'
        ]
      },

      {
        label: 'Premium Fabrics',

        fabrics: [
          'Chiffon Diamond',
          'Chiffon Pleat',
          'Silk Satin',
          'Turkish Voile',
          'Ultra Fine Voile',
          'Satin Hermes',
          'Sakura Cotton'
        ]
      }

    ],


    twilly: [

      {
        label: 'FABX Catalogue Fabric',

        fabrics: [
          'Satin Hermes'
        ]
      }

    ],


    accessories: [

      {
        label: 'Signature Fabrics',

        fabrics: [
          'Satin Velvet',
          'Satin Cavalli'
        ]
      },

      {
        label: 'Premium Fabrics',

        fabrics: [
          'Satin Hermes'
        ]
      }

    ],


    furoshiki: [

      {
        label: 'Signature Fabrics',

        fabrics: [
          'BSY'
        ]
      },

      {
        label: 'Premium Fabrics',

        fabrics: [
          'Sakura Cotton'
        ]
      }

    ],


    diningTabletop: [

      {
        label: 'Essential Fabrics',

        fabrics: [
          'BSY'
        ]
      },

      {
        label: 'Signature Fabrics',

        fabrics: [
          'Canvas Linen',
          'Baby Canvas',
          'Canvas Crafting'
        ]
      },

      {
        label: 'Premium Fabrics',

        fabrics: [
          'Satin Duchess',
          'Sakura Cotton'
        ]
      }

    ],


    drawstring: [

      {
        label: 'Essential Fabrics',

        fabrics: [
          'Satin',
          'BSY',
          'Taslan'
        ]
      },

      {
        label: 'Signature Fabrics',

        fabrics: [
          'Canvas Linen',
          'Baby Canvas',
          'Canvas Crafting'
        ]
      },

      {
        label: 'Premium Fabrics',

        fabrics: [
          'Satin Duchess',
          'Sakura Cotton'
        ]
      }

    ],


    cushion: [

      {
        label: 'Essential Fabrics',

        fabrics: [
          'BSY'
        ]
      },

      {
        label: 'Signature Fabrics',

        fabrics: [
          'Canvas Linen',
          'Baby Canvas',
          'Canvas Crafting'
        ]
      },

      {
        label: 'Premium Fabrics',

        fabrics: [
          'Yelvo',
          'Canvas',
          'Sakura Cotton'
        ]
      }

    ],


    pocketSquare: [

      {
        label: 'Established FABX Fabric',

        fabrics: [
          'Satin Hermes'
        ]
      }

    ]

  };


  /* =========================================================
     STANDARD GIFT PRESENTATION
     ========================================================= */

  var GIFT_PRESENTATION_FORMATS = [

    'Scarf 45 — 45 × 45 cm',
    'Scarf 50 — 50 × 50 cm',
    'Scarf 70 — 70 × 70 cm',
    'Scarf 90 — 90 × 90 cm',
    'Twilly — 5 × 95 cm',
    'Twilly Scarf — 10 × 120 cm'

  ];


  /* =========================================================
     BASIC HELPERS
     ========================================================= */

  function el(id) {
    return document.getElementById(id);
  }


  function value(id) {

    return el(id)
      ? el(id).value.trim()
      : '';

  }


  function setError(
    id,
    message
  ) {

    var target =
      el(id);

    if (target) {
      target.textContent =
        message || '';
    }

    return !!message;

  }


  function toYMD(date) {

    return (
      date.getFullYear() +
      '-' +
      String(
        date.getMonth() + 1
      ).padStart(
        2,
        '0'
      ) +
      '-' +
      String(
        date.getDate()
      ).padStart(
        2,
        '0'
      )
    );

  }


  function formatDate(date) {

    return date.toLocaleDateString(
      'en-GB',
      {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }
    );

  }


  function formatYMD(ymd) {

    if (!ymd) {
      return '(not provided)';
    }

    return formatDate(
      new Date(
        ymd +
        'T00:00:00'
      )
    );

  }


  function getTodaySG() {

    var parts =
      new Intl.DateTimeFormat(
        'en-CA',
        {
          timeZone:
            'Asia/Singapore',

          year:
            'numeric',

          month:
            '2-digit',

          day:
            '2-digit'
        }
      ).formatToParts(
        new Date()
      );


    var map = {};


    parts.forEach(
      function (part) {

        map[
          part.type
        ] =
          part.value;

      }
    );


    return new Date(
      map.year +
      '-' +
      map.month +
      '-' +
      map.day +
      'T00:00:00'
    );

  }


  function getSingaporeClockMinutes() {

    var parts =
      new Intl.DateTimeFormat(
        'en-GB',
        {
          timeZone:
            'Asia/Singapore',

          hour:
            '2-digit',

          minute:
            '2-digit',

          hourCycle:
            'h23'
        }
      ).formatToParts(
        new Date()
      );


    var map = {};


    parts.forEach(
      function (part) {

        map[
          part.type
        ] =
          part.value;

      }
    );


    return (
      Number(
        map.hour || 0
      ) * 60 +

      Number(
        map.minute || 0
      )
    );

  }


  function sameDayReleaseCutoffMinutes() {

    return (
      SAME_DAY_RELEASE_CUTOFF_HOUR_SGT *
      60
    ) +
    SAME_DAY_RELEASE_CUTOFF_MINUTE_SGT;

  }


  function getSingaporeDateParts() {

    var parts =
      new Intl.DateTimeFormat(
        'en-GB',
        {
          timeZone:
            'Asia/Singapore',

          year:
            '2-digit',

          month:
            '2-digit',

          day:
            '2-digit'
        }
      ).formatToParts(
        new Date()
      );


    var map = {};


    parts.forEach(
      function (part) {

        map[
          part.type
        ] =
          part.value;

      }
    );


    return {
      yy:
        map.year,

      mm:
        map.month,

      dd:
        map.day
    };

  }


  function randomCode(length) {

    var chars =
      'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';


    var result =
      '';


    for (
      var i = 0;
      i < length;
      i++
    ) {

      result +=
        chars.charAt(
          Math.floor(
            Math.random() *
            chars.length
          )
        );

    }


    return result;

  }


  function generateProjectRef() {

    var p =
      getSingaporeDateParts();


    return (
      'Q-' +
      p.yy +
      p.mm +
      p.dd +
      '-' +
      randomCode(
        3
      )
    );

  }


  /* =========================================================
     FORM ELEMENTS
     ========================================================= */

  var form =
    el(
      'fabx-corporate-form'
    );


  if (!form) {
    return;
  }


  var companyTypeInput =
    el(
      'fabx-company-type'
    );


  var projectStageInput =
    el(
      'fabx-project-stage'
    );


  var useTypeInput =
    el(
      'fabx-use-type'
    );


  var fixedEventInput =
    el(
      'fabx-fixed-event'
    );


  var productInput =
    el(
      'fabx-product'
    );


  var formatInput =
    el(
      'fabx-format'
    );


  var materialInput =
    el(
      'fabx-material'
    );


  var qtyInput =
    el(
      'fabx-qty'
    );


  var qtyStatusInput =
    el(
      'fabx-qty-status'
    );


  var designsInput =
    el(
      'fabx-designs'
    );


  var artworkInput =
    el(
      'fabx-artwork'
    );


  var presentationInput =
    el(
      'fabx-presentation'
    );


  var sampleInput =
    el(
      'fabx-sample-required'
    );


  var inHandInput =
    el(
      'fabx-inhand-date'
    );


  var preferredDateInput =
    el(
      'fabx-preferred-date'
    );


  var eventDateInput =
    el(
      'fabx-event-date'
    );


  var insertInput =
    el(
      'fabx-insert'
    );


  var btn =
    el(
      'fabx-submit'
    );


  var projectBody =
    el(
      'fabx-project-body'
    );


  var productFormatGrid =
    el(
      'fabx-product-format-grid'
    );


  /* =========================================================
     PROJECT / ROUTE HELPERS
     ========================================================= */

  function isIntermediary(
    companyType
  ) {

    return (
      companyType ===
        'Agency / Events / Marketing / Design' ||

      companyType ===
        'Other Intermediary'
    );

  }


  function recipientApplies(
    useType
  ) {

    return (
      useType ===
        'Event / Activation / Launch' ||

      useType ===
        'Corporate / VIP Gifting'
    );

  }


  function isCatalogueStage(
    stage
  ) {

    return (
      stage ===
        'Exploring / Comparing Options' ||

      stage ===
        'Shortlisted / Under Internal or Client Review'
    );

  }


  function isRepeatStage(
    stage
  ) {

    return (
      stage ===
      'Repeat / Replenishment Order'
    );

  }


  /*
  The client's sample answer drives the automatic
  feasibility calculation.

  YES or NOT SURE:
  include one Client Approval Sample + 3 approval days.

  NO:
  calculate the no-sample production route.

  FABX retains authority to add physical validation after
  reviewing a new / changed / otherwise unvalidated project.
  */
  function clientPhysicalSampleApprovalRequired() {

    return !!(
      sampleInput &&
      (
        sampleInput.value ===
          'Yes' ||

        sampleInput.value ===
          'Not Sure Yet'
      )
    );

  }


  function physicalSamplePlanningDays() {

    if (
      !clientPhysicalSampleApprovalRequired()
    ) {

      return 0;

    }


    return (
      PHYSICAL_SAMPLE_STAGE_WD +
      CLIENT_SAMPLE_APPROVAL_WD
    );

  }


  function getFabxSamplePolicyText() {

    var answer =
      sampleInput
        ? sampleInput.value
        : '';


    if (
      answer ===
      'Yes'
    ) {

      return (
        'Client / end-client physical sample approval required. The feasibility check includes one Client Approval Sample round plus a minimum 3-working-day client approval / final-lock window before Production Release.'
      );

    }


    if (
      answer ===
      'Not Sure Yet'
    ) {

      return (
        'Sample approval requirement is not confirmed. The feasibility check plans conservatively with one Client Approval Sample round plus a minimum 3-working-day client approval / final-lock window.'
      );

    }


    if (
      answer ===
      'No'
    ) {

      return (
        'No client-requested physical sample approval. FABX may still require physical validation after project review; if required, timing will be recalculated before acceptance.'
      );

    }


    return (
      'Physical sample requirement to be confirmed during project review.'
    );

  }


  function updateSampleRequirementNote() {

    if (!sampleInput) {
      return;
    }


    var field =
      sampleInput.closest(
        '.fabx-field'
      );


    if (!field) {
      return;
    }


    var note =
      field.querySelector(
        '.fabx-note'
      );


    if (!note) {
      return;
    }


    note.textContent =
      'This asks whether your team or end client requires its own physical sample approval. If Yes or Not Sure, the feasibility check includes one Client Approval Sample round plus a minimum 3-working-day client approval / final-lock window before Production Release. FABX may still require physical validation after reviewing a new, changed or otherwise unvalidated configuration.';

  }


  /* =========================================================
     WORKING DAYS
     ========================================================= */

  function isWorkingDay(date) {

    var weekday =
      date.getDay();


    if (
      weekday === 0 ||
      weekday === 6
    ) {

      return false;

    }


    return (
      FABX_BLACKOUT_DATES.indexOf(
        toYMD(
          date
        )
      ) === -1
    );

  }


  function isWeekendDate(date) {

    var day =
      date.getDay();


    return (
      day === 0 ||
      day === 6
    );

  }


  function isWeekendYMD(ymd) {

    if (!ymd) {
      return false;
    }


    return isWeekendDate(
      new Date(
        ymd +
        'T00:00:00'
      )
    );

  }


  function addWorkingDays(
    date,
    days
  ) {

    var result =
      new Date(
        date
      );


    var added =
      0;


    while (
      added < days
    ) {

      result.setDate(
        result.getDate() + 1
      );


      if (
        isWorkingDay(
          result
        )
      ) {

        added++;

      }

    }


    return result;

  }


  function subtractWorkingDays(
    date,
    days
  ) {

    var result =
      new Date(
        date
      );


    var removed =
      0;


    while (
      removed < days
    ) {

      result.setDate(
        result.getDate() - 1
      );


      if (
        isWorkingDay(
          result
        )
      ) {

        removed++;

      }

    }


    return result;

  }


  function countWorkingDaysBetween(
    start,
    end
  ) {

    if (
      !start ||
      !end ||
      end < start
    ) {

      return 0;

    }


    var cursor =
      new Date(
        start
      );


    var count =
      0;


    while (
      cursor < end
    ) {

      cursor.setDate(
        cursor.getDate() + 1
      );


      if (
        isWorkingDay(
          cursor
        )
      ) {

        count++;

      }

    }


    return count;

  }


  function getPlanningStartDate() {

    var today =
      getTodaySG();


    if (
      !isWorkingDay(
        today
      )
    ) {

      return addWorkingDays(
        today,
        1
      );

    }


    /*
    Same-day supplier release requires FABX to be
    production-ready before the 2 PM SGT cutoff.
    */
    if (
      getSingaporeClockMinutes() >=
      sameDayReleaseCutoffMinutes()
    ) {

      return addWorkingDays(
        today,
        1
      );

    }


    return today;

  }


  function releaseCutoffNote(
    releaseBy
  ) {

    if (
      !releaseBy ||
      toYMD(
        releaseBy
      ) !==
      toYMD(
        getTodaySG()
      )
    ) {

      return '';

    }


    return (
      ' Same-day Production Release must be completed before FABX’s daily release cutoff.'
    );

  }


  /* =========================================================
     DESIGN / FORMAT HELPERS
     ========================================================= */

  function designCountNumber(
    designs
  ) {

    if (
      designs ===
      '1 Design'
    ) {
      return 1;
    }

    if (
      designs ===
      '2 Designs'
    ) {
      return 2;
    }

    if (
      designs ===
      '3 Designs'
    ) {
      return 3;
    }

    if (
      designs ===
      '4 Designs'
    ) {
      return 4;
    }

    if (
      designs ===
      '5 or More Designs'
    ) {
      return 5;
    }

    return 0;

  }


  function formatIsCustom(
    format
  ) {

    if (!format) {
      return false;
    }


    return (
      format.indexOf(
        'Bespoke'
      ) !== -1 ||

      format.indexOf(
        'Other / Custom'
      ) !== -1 ||

      format.indexOf(
        'Other / Bespoke'
      ) !== -1
    );

  }


  function isBespokeMaterial(
    material
  ) {

    return [

      '100% Silk Twill — Bespoke',

      '100% Natural Fabric — Bespoke Review',

      'Client-Specified / Special Material — Bespoke Review',

      '100% Silk Component Required — Bespoke',

      '100% Natural Component Required — Bespoke Review'

    ].indexOf(
      material
    ) !== -1;

  }


  /* =========================================================
     FORMAT OPTIONS
     ========================================================= */

  function populateFormatOptions() {

    var product =
      productInput.value;


    var formats =
      STANDARD_FORMATS[
        product
      ] || [];


    formatInput.innerHTML =
      '<option value="">Please Select</option>';


    formats.forEach(
      function (format) {

        var option =
          document.createElement(
            'option'
          );


        option.value =
          format;


        option.textContent =
          format;


        formatInput.appendChild(
          option
        );

      }
    );


    if (!product) {

      el(
        'fabx-format-field'
      ).style.display =
        'none';


      productFormatGrid.classList.remove(
        'has-format'
      );


      return;

    }


    /*
    Single-format products do not need a visible
    second dropdown.
    */
    if (
      formats.length === 1
    ) {

      formatInput.value =
        formats[0];


      el(
        'fabx-format-field'
      ).style.display =
        'none';


      productFormatGrid.classList.remove(
        'has-format'
      );

    }

    else {

      el(
        'fabx-format-field'
      ).style.display =
        'block';


      productFormatGrid.classList.add(
        'has-format'
      );

    }

  }


  /* =========================================================
     MATERIAL / FABRIC ROUTING
     ========================================================= */

  function getFabricContext(
    product,
    format
  ) {

    if (!format) {
      return null;
    }


    if (
      product ===
      'Scarf / Carré'
    ) {

      return 'scarves';

    }


    if (
      format ===
        'Twilly — 5 × 95 cm' ||

      format ===
        'Twilly Scarf — 10 × 120 cm'
    ) {

      return 'twilly';

    }


    if (
      format ===
        'Twilly Bag Charm — 5 × 45 cm' ||

      format ===
        'Scarf Bag Charm — 30 × 30 cm' ||

      format ===
        'Fabric Bookmark — 5 × 15 cm'
    ) {

      return 'accessories';

    }


    if (
      product ===
      'Furoshiki / Reusable Gift Wrap Cloth'
    ) {

      return 'furoshiki';

    }


    if (
      product ===
      'Pocket Square'
    ) {

      return 'pocketSquare';

    }


    if (
      product ===
        'Coaster / Tray / Desk & Table Gift' ||

      product ===
        'Napkin / Placemat / Dining Gift' ||

      product ===
        'Table Runner / Event Table Styling'
    ) {

      return 'diningTabletop';

    }


    if (
      product ===
      'Pouch / Bag / Utility Textile Gift'
    ) {

      return 'drawstring';

    }


    if (
      product ===
      'Cushion Cover'
    ) {

      return 'cushion';

    }


    return null;

  }


  function silkRouteRelevant(
    product
  ) {

    return [

      'Scarf / Carré',
      'Twilly / Bag Charm',
      'Pocket Square'

    ].indexOf(
      product
    ) !== -1;

  }


  function naturalRouteRelevant(
    product
  ) {

    return [

      'Scarf / Carré',
      'Furoshiki / Reusable Gift Wrap Cloth',
      'Pocket Square',
      'Fabric Bookmark / Small Textile Keepsake',
      'Coaster / Tray / Desk & Table Gift',
      'Napkin / Placemat / Dining Gift',
      'Table Runner / Event Table Styling',
      'Pouch / Bag / Utility Textile Gift',
      'Cushion Cover',
      'Printed Fabric Only — No Sewing',
      'Custom Sewn Textile Product',
      'Gift Set / Multiple Items',
      'Others'

    ].indexOf(
      product
    ) !== -1;

  }


  function addOption(
    parent,
    text
  ) {

    var option =
      document.createElement(
        'option'
      );


    option.value =
      text;


    option.textContent =
      text;


    parent.appendChild(
      option
    );

  }


  function setMaterialLabel(
    text
  ) {

    var label =
      document.querySelector(
        'label[for="fabx-material"]'
      );


    if (label) {
      label.textContent =
        text;
    }

  }


  function populateEstablishedProductFabrics(
    product,
    format
  ) {

    var context =
      getFabricContext(
        product,
        format
      );


    if (
      context &&
      FABRIC_GROUPS[
        context
      ]
    ) {

      FABRIC_GROUPS[
        context
      ].forEach(
        function (group) {

          var optgroup =
            document.createElement(
              'optgroup'
            );


          optgroup.label =
            group.label;


          group.fabrics.forEach(
            function (fabric) {

              addOption(
                optgroup,
                fabric
              );

            }
          );


          materialInput.appendChild(
            optgroup
          );

        }
      );

    }


    var special =
      document.createElement(
        'optgroup'
      );


    special.label =
      'Bespoke / Special Material';


    if (
      silkRouteRelevant(
        product
      )
    ) {

      addOption(
        special,
        '100% Silk Twill — Bespoke'
      );

    }


    if (
      naturalRouteRelevant(
        product
      )
    ) {

      addOption(
        special,
        '100% Natural Fabric — Bespoke Review'
      );

    }


    addOption(
      special,
      'Client-Specified / Special Material — Bespoke Review'
    );


    materialInput.appendChild(
      special
    );


    var unsure =
      document.createElement(
        'optgroup'
      );


    unsure.label =
      'Not Sure';


    addOption(
      unsure,
      'Open to FABX Recommendation'
    );


    materialInput.appendChild(
      unsure
    );

  }


  function populateMaterialOptions() {

    var product =
      productInput.value;


    var format =
      formatInput.value;


    materialInput.innerHTML =
      '<option value="">Please Select</option>';


    if (!format) {
      return;
    }


    if (
      product ===
      'Printed Fabric Only — No Sewing'
    ) {

      setMaterialLabel(
        'Fabric Range'
      );


      addOption(
        materialInput,
        'FABX Fabric Printing Collection — Full Range'
      );


      addOption(
        materialInput,
        '100% Natural Fabric — Bespoke Review'
      );


      addOption(
        materialInput,
        'Client-Specified / Special Material — Bespoke Review'
      );


      addOption(
        materialInput,
        'Open to FABX Recommendation'
      );


      return;

    }


    if (
      product ===
      'Custom Sewn Textile Product'
    ) {

      setMaterialLabel(
        'Material Direction'
      );


      addOption(
        materialInput,
        'FABX Fabric Collection — FABX to Recommend'
      );


      addOption(
        materialInput,
        '100% Silk Twill — Bespoke'
      );


      addOption(
        materialInput,
        '100% Natural Fabric — Bespoke Review'
      );


      addOption(
        materialInput,
        'Client-Specified / Special Material — Bespoke Review'
      );


      addOption(
        materialInput,
        'Open to FABX Recommendation'
      );


      return;

    }


    if (
      product ===
      'Gift Set / Multiple Items'
    ) {

      setMaterialLabel(
        'Material Direction'
      );


      addOption(
        materialInput,
        'FABX Fabric Collection — Component-Specific Selection'
      );


      addOption(
        materialInput,
        '100% Silk Component Required — Bespoke'
      );


      addOption(
        materialInput,
        '100% Natural Component Required — Bespoke Review'
      );


      addOption(
        materialInput,
        'Client-Specified / Special Material — Bespoke Review'
      );


      addOption(
        materialInput,
        'Open to FABX Recommendation'
      );


      return;

    }


    if (
      product ===
      'Others'
    ) {

      setMaterialLabel(
        'Material Direction'
      );


      addOption(
        materialInput,
        'Material to Be Confirmed After Product Review'
      );


      addOption(
        materialInput,
        '100% Silk Component Required — Bespoke'
      );


      addOption(
        materialInput,
        '100% Natural Component Required — Bespoke Review'
      );


      addOption(
        materialInput,
        'Client-Specified / Special Material — Bespoke Review'
      );


      addOption(
        materialInput,
        'Open to FABX Recommendation'
      );


      return;

    }


    setMaterialLabel(
      'Fabric'
    );


    populateEstablishedProductFabrics(
      product,
      format
    );

  }


  /* =========================================================
     MATERIAL NOTES
     ========================================================= */

  function updateMaterialNote() {

    var product =
      productInput.value;


    var material =
      materialInput.value;


    var note =
      el(
        'fabx-material-note'
      );


    var designNote =
      el(
        'fabx-design-note'
      );


    if (!note || !designNote) {
      return;
    }


    designNote.textContent =
      'Up to 4 designs may remain within an established standard route. Higher design counts require managed project review.';


    if (
      material ===
        '100% Silk Twill — Bespoke' ||

      material ===
        '100% Silk Component Required — Bespoke'
    ) {

      note.textContent =
        '100% silk is handled through Bespoke review. Allow 6–8 weeks or more for development, approval and production. 100% Silk Twill has a minimum of 20 pcs per design.';


      designNote.textContent =
        '100% Silk Twill has a minimum of 20 pcs per design. Silk projects do not receive automatic Standard deadline confirmation.';


      return;

    }


    if (
      material ===
        '100% Natural Fabric — Bespoke Review' ||

      material ===
        '100% Natural Component Required — Bespoke Review'
    ) {

      note.textContent =
        'A mandatory 100% natural-fibre requirement requires Bespoke review before material and timing can be confirmed.';


      return;

    }


    if (
      material ===
      'Client-Specified / Special Material — Bespoke Review'
    ) {

      note.textContent =
        'Client-specified or special materials require Bespoke review before pricing or timing can be confirmed.';


      return;

    }


    if (
      material ===
      'FABX Fabric Printing Collection — Full Range'
    ) {

      note.textContent =
        'Printed Fabric Only uses FABX’s wider fabric-printing collection. Final fabric, printable width, panel size and yield are reviewed before quotation.';


      return;

    }


    if (
      material ===
      'FABX Fabric Collection — FABX to Recommend'
    ) {

      note.textContent =
        'FABX will recommend a suitable existing fabric after reviewing the proposed product and intended finish.';


      return;

    }


    if (
      material ===
      'FABX Fabric Collection — Component-Specific Selection'
    ) {

      note.textContent =
        'FABX will select suitable existing fabrics separately for each textile component in the gift set.';


      return;

    }


    if (
      material ===
      'Material to Be Confirmed After Product Review'
    ) {

      note.textContent =
        'FABX will define the product route first, then recommend the appropriate material.';


      return;

    }


    if (
      material ===
      'Open to FABX Recommendation'
    ) {

      note.textContent =
        'FABX will recommend an appropriate existing fabric or material route based on the product, artwork and intended finish.';


      return;

    }


    if (material) {

      note.textContent =
        material +
        ' is a current FABX catalogue fabric for this product format. Fabric names do not guarantee fibre composition; select the Bespoke route if 100% silk or 100% natural fibre is mandatory.';


      return;

    }


    if (
      product ===
        'Custom Sewn Textile Product' ||

      product ===
        'Gift Set / Multiple Items' ||

      product ===
        'Others'
    ) {

      note.textContent =
        'Select the material direction that best describes the brief. FABX will refine the exact material during review.';


      return;

    }


    note.textContent =
      'Select a fabric after choosing the FABX product format.';

  }


  /* =========================================================
     INSERT AVAILABILITY
     ========================================================= */

  function updateInsertAvailability() {

    var quantity =
      Number(
        qtyInput.value || 0
      );


    var note =
      el(
        'fabx-insert-note'
      );


    if (!note) {
      return;
    }


    if (
      quantity > 0 &&
      quantity < 50
    ) {

      if (
        insertInput.value ===
        'Custom Front Care / Event Insert — Client-Supplied Artwork'
      ) {

        insertInput.value =
          'Standard FABX Care Card';

      }


      note.textContent =
        'Custom front care/event inserts are available from 50 pcs.';

    }

    else {

      note.textContent =
        'Custom front care/event inserts are available from 50 pcs on eligible projects.';

    }

  }


  /* =========================================================
     REFERENCE FIELD
     ========================================================= */

  function isReferenceHelpful() {

    var product =
      productInput.value;


    var format =
      formatInput.value;


    var material =
      materialInput.value;


    var artwork =
      artworkInput.value;


    var presentation =
      presentationInput.value;


    return (
      product ===
        'Custom Sewn Textile Product' ||

      product ===
        'Gift Set / Multiple Items' ||

      product ===
        'Others' ||

      formatIsCustom(
        format
      ) ||

      isBespokeMaterial(
        material
      ) ||

      artwork ===
        'Need FABX to Adapt / Develop Artwork' ||

      presentation ===
        'Custom / Bespoke Presentation Required'
    );

  }


  /* =========================================================
     CONDITIONAL FIELDS
     ========================================================= */

  function updateConditionalFields() {

    var companyType =
      companyTypeInput.value;


    var stage =
      projectStageInput.value;


    var useType =
      useTypeInput.value;


    var fixedEvent =
      fixedEventInput.value;


    var format =
      formatInput.value;


    var sampleRequired =
      sampleInput.value;


    var presentation =
      presentationInput.value;


    var catalogue =
      isCatalogueStage(
        stage
      );


    el(
      'fabx-catalogue-gate'
    ).style.display =
      catalogue
        ? 'block'
        : 'none';


    projectBody.style.display =
      catalogue
        ? 'none'
        : 'block';


    if (catalogue) {
      return;
    }


    var showEndClient =
      isIntermediary(
        companyType
      );


    el(
      'fabx-end-client-field'
    ).style.display =
      showEndClient
        ? 'block'
        : 'none';


    if (!showEndClient) {

      el(
        'fabx-end-client'
      ).value =
        '';


      setError(
        'err-end-client',
        ''
      );

    }


    var showRecipient =
      recipientApplies(
        useType
      );


    el(
      'fabx-recipient-field'
    ).style.display =
      showRecipient
        ? 'block'
        : 'none';


    if (!showRecipient) {

      el(
        'fabx-recipient'
      ).value =
        '';


      setError(
        'err-recipient',
        ''
      );

    }


    /*
    Show Event / Use Date whenever this is an event project
    or the user explicitly says the date is fixed.
    */
    var showEventDate =
      fixedEvent ===
        'Yes' ||

      useType ===
        'Event / Activation / Launch';


    el(
      'fabx-event-date-field'
    ).style.display =
      showEventDate
        ? 'block'
        : 'none';


    if (!showEventDate) {

      eventDateInput.value =
        '';


      setError(
        'err-event-date',
        ''
      );

    }


    var showMaterial =
      !!format;


    el(
      'fabx-material-field'
    ).style.display =
      showMaterial
        ? 'block'
        : 'none';


    if (!showMaterial) {

      materialInput.value =
        '';


      setError(
        'err-material',
        ''
      );

    }


    var showMaterialSelected =
      showMaterial &&
      sampleRequired ===
        'Yes';


    el(
      'fabx-material-selected-field'
    ).style.display =
      showMaterialSelected
        ? 'block'
        : 'none';


    if (!showMaterialSelected) {

      el(
        'fabx-material-selected'
      ).value =
        '';


      setError(
        'err-material-selected',
        ''
      );

    }


    var showCustomPresentation =
      presentation ===
      'Custom / Bespoke Presentation Required';


    el(
      'fabx-custom-presentation-field'
    ).style.display =
      showCustomPresentation
        ? 'block'
        : 'none';


    if (!showCustomPresentation) {

      el(
        'fabx-custom-presentation'
      ).value =
        '';


      setError(
        'err-custom-presentation',
        ''
      );

    }


    var showReference =
      isReferenceHelpful();


    el(
      'fabx-reference-field'
    ).style.display =
      showReference
        ? 'block'
        : 'none';


    if (!showReference) {

      el(
        'fabx-reference'
      ).value =
        '';

    }


    updateMaterialNote();

    updateInsertAvailability();

    updateSampleRequirementNote();

    updateRouteAndDeadline();

  }


  /* =========================================================
     ROUTE CLASSIFICATION
     ========================================================= */

  function classifyRoute() {

    var stage =
      projectStageInput.value;


    var product =
      productInput.value;


    var format =
      formatInput.value;


    var material =
      materialInput.value;


    var quantity =
      Number(
        qtyInput.value || 0
      );


    var quantityStatus =
      qtyStatusInput.value;


    var designs =
      designsInput.value;


    var artwork =
      artworkInput.value;


    var presentation =
      presentationInput.value;


    var sampleRequired =
      sampleInput.value;


    var catalogueReasons = [];
    var bespokeReasons = [];
    var managedReasons = [];


    if (
      stage ===
      'Exploring / Comparing Options'
    ) {

      catalogueReasons.push(
        'Project direction is still being explored.'
      );

    }


    if (
      stage ===
      'Shortlisted / Under Internal or Client Review'
    ) {

      catalogueReasons.push(
        'Project direction is still awaiting internal or end-client approval.'
      );

    }


    if (
      catalogueReasons.length
    ) {

      return {
        route:
          'CATALOGUE',

        reasons:
          catalogueReasons
      };

    }


    if (
      product ===
      'Custom Sewn Textile Product'
    ) {

      bespokeReasons.push(
        'Custom sewn product requires Bespoke Product Development.'
      );

    }


    if (
      product ===
      'Gift Set / Multiple Items'
    ) {

      bespokeReasons.push(
        'Multi-item gift set requires Bespoke project review.'
      );

    }


    if (
      product ===
      'Others'
    ) {

      bespokeReasons.push(
        'Non-catalogue product requires Bespoke review.'
      );

    }


    if (
      formatIsCustom(
        format
      )
    ) {

      bespokeReasons.push(
        'Selected dimensions / format sit outside established FABX formats.'
      );

    }


    if (
      isBespokeMaterial(
        material
      )
    ) {

      bespokeReasons.push(
        'Selected material requirement requires Bespoke review.'
      );

    }


    if (
      artwork ===
      'Need FABX to Adapt / Develop Artwork'
    ) {

      bespokeReasons.push(
        'Artwork adaptation/development requires Bespoke Artwork + Print review.'
      );

    }


    if (
      presentation ===
      'Custom / Bespoke Presentation Required'
    ) {

      bespokeReasons.push(
        'Custom structural presentation requires Bespoke Presentation Development.'
      );

    }


    if (
      bespokeReasons.length
    ) {

      return {
        route:
          'BESPOKE',

        reasons:
          bespokeReasons
      };

    }


    if (
      product ===
      'Printed Fabric Only — No Sewing'
    ) {

      managedReasons.push(
        'Printed Fabric Only requires managed fabric-printing review.'
      );

    }


    if (
      quantity >= 300
    ) {

      managedReasons.push(
        '300+ pcs requires managed capacity review.'
      );

    }


    if (
      designs ===
      '5 or More Designs'
    ) {

      managedReasons.push(
        '5+ designs requires managed artwork/production review.'
      );

    }


    if (
      designs ===
      'Not Confirmed Yet'
    ) {

      managedReasons.push(
        'Design count is not confirmed.'
      );

    }


    if (
      quantityStatus ===
        'Estimated' ||

      quantityStatus ===
        'Planning Range'
    ) {

      managedReasons.push(
        'Quantity is not commercially locked.'
      );

    }


    if (
      artwork ===
      'Not Confirmed Yet'
    ) {

      managedReasons.push(
        'Artwork status is not confirmed.'
      );

    }


    if (
      presentation ===
      'Not Confirmed Yet'
    ) {

      managedReasons.push(
        'Presentation route is not confirmed.'
      );

    }


    if (
      sampleRequired ===
      'Yes'
    ) {

      managedReasons.push(
        'Client/end-client requires physical sample approval before bulk.'
      );

    }


    if (
      sampleRequired ===
      'Not Sure Yet'
    ) {

      managedReasons.push(
        'Client/end-client sample approval requirement is not confirmed.'
      );

    }


    if (
      presentation ===
        'FABX Gift Presentation — Standard Add-On' &&

      GIFT_PRESENTATION_FORMATS.indexOf(
        format
      ) === -1
    ) {

      managedReasons.push(
        'Selected format does not have a standard FABX Gift Presentation route.'
      );

    }


    if (
      !product ||
      !format ||
      !material ||
      !quantity ||
      !quantityStatus ||
      !designs ||
      !artwork ||
      !presentation ||
      !sampleRequired
    ) {

      managedReasons.push(
        'Some routing information is incomplete.'
      );

    }


    if (
      managedReasons.length
    ) {

      return {
        route:
          'MANAGED CORPORATE',

        reasons:
          managedReasons
      };

    }


    return {

      route:
        'STANDARD',

      reasons: [

        'Established FABX product and format.',

        'Current FABX catalogue fabric or FABX-recommended standard fabric.',

        'No Bespoke artwork, product, material or structural-presentation trigger identified.',

        'Quantity and design complexity remain within the Standard route.'

      ]

    };

  }


  /* =========================================================
     EARLIEST FEASIBLE DATES
     ========================================================= */

  function rushScopeIsEligible() {

    var quantity =
      Number(
        qtyInput.value || 0
      );


    return !!(
      FABX_RUSH_AVAILABLE &&
      quantity > 0 &&
      quantity <= 100 &&
      designsInput.value ===
        '1 Design'
    );

  }


  function earliestIndicativeDates() {

    var planningStart =
      getPlanningStartDate();


    /*
    If sample = Yes / Not Sure:
    10 wd sample + 3 wd client approval/final lock.

    If sample = No:
    Production Release may begin from planning start.
    */
    var preBulkDays =
      physicalSamplePlanningDays();


    var earliestProductionRelease =
      preBulkDays > 0

        ?

      addWorkingDays(
        planningStart,
        preBulkDays
      )

        :

      planningStart;


    return {

      productionRelease:
        earliestProductionRelease,


      rush:
        addWorkingDays(
          earliestProductionRelease,
          RUSH_TO_INHAND_WD
        ),


      standard:
        addWorkingDays(
          earliestProductionRelease,
          STANDARD_TO_INHAND_WD
        )

    };

  }


  function earliestIndicativeDatesText() {

    var dates =
      earliestIndicativeDates();


    var sampleStageRequired =
      physicalSamplePlanningDays() > 0;


    var prefix =
      sampleStageRequired

        ?

      'With one Client Approval Sample round plus the minimum 3-working-day client approval / final-lock window, the earliest indicative in-hand dates are '

        :

      'The earliest indicative in-hand dates are ';


    if (
      rushScopeIsEligible()
    ) {

      return (
        prefix +
        'Rush ' +
        formatDate(
          dates.rush
        ) +
        ' and Standard ' +
        formatDate(
          dates.standard
        ) +
        '.'
      );

    }


    return (
      prefix +
      'Standard ' +
      formatDate(
        dates.standard
      ) +
      '.'
    );

  }


  function isComplexBespokeRoute() {

    var product =
      productInput.value;


    var material =
      materialInput.value;


    var presentation =
      presentationInput.value;


    return (
      product ===
        'Custom Sewn Textile Product' ||

      product ===
        'Gift Set / Multiple Items' ||

      material ===
        '100% Silk Twill — Bespoke' ||

      material ===
        '100% Silk Component Required — Bespoke' ||

      material ===
        'Client-Specified / Special Material — Bespoke Review' ||

      presentation ===
        'Custom / Bespoke Presentation Required'
    );

  }


  /* =========================================================
     DEADLINE ASSESSMENT
     ========================================================= */

  function assessDeadline(
    routeInfo
  ) {

    var inHand =
      inHandInput.value;


    var quantity =
      Number(
        qtyInput.value || 0
      );


    var designs =
      designsInput.value;


    var artwork =
      artworkInput.value;


    var stage =
      projectStageInput.value;


    var planningStart =
      getPlanningStartDate();


    if (!inHand) {

      return {

        status:
          'NOT ASSESSED',

        title:
          'Enter your latest in-hand date',

        copy:
          'FABX will check the applicable Standard, Rush or Bespoke window.'

      };

    }


    if (
      isWeekendYMD(
        inHand
      )
    ) {

      return {

        status:
          'INVALID IN-HAND DATE',

        title:
          'Choose a weekday in-hand date',

        copy:
          'FABX operational delivery dates must fall on Monday–Friday. If your event is on a weekend, choose the preceding working day.'

      };

    }


    if (
      routeInfo.route ===
      'CATALOGUE'
    ) {

      return {

        status:
          'CATALOGUE',

        title:
          'Deadline not assessed at shortlisting stage',

        copy:
          'Start with the Corporate Catalogue. Timing is checked once the project direction is defined.'

      };

    }


    var target =
      new Date(
        inHand +
        'T00:00:00'
      );


    var workingDaysToTarget =
      countWorkingDaysBetween(
        planningStart,
        target
      );


    var standardReleaseBy =
      subtractWorkingDays(
        target,
        STANDARD_TO_INHAND_WD
      );


    var rushReleaseBy =
      subtractWorkingDays(
        target,
        RUSH_TO_INHAND_WD
      );


    var preBulkDays =
      physicalSamplePlanningDays();


    var sampleStageRequired =
      preBulkDays > 0;


    /*
    Earliest point at which bulk may reach Production Release.

    If sample is required this already includes:
    10 wd sample + 3 wd client approval / final lock.
    */
    var earliestProductionRelease =
      sampleStageRequired

        ?

      addWorkingDays(
        planningStart,
        preBulkDays
      )

        :

      planningStart;


    var sampleFitsBeforeStandardRelease =
      !sampleStageRequired ||
      earliestProductionRelease <=
      standardReleaseBy;


    var sampleFitsBeforeRushRelease =
      !sampleStageRequired ||
      earliestProductionRelease <=
      rushReleaseBy;


    var standardReleaseStillPossible =
      standardReleaseBy >=
      planningStart;


    var rushReleaseStillPossible =
      rushReleaseBy >=
      planningStart;


    var earliestText =
      earliestIndicativeDatesText();


    var artworkCaveat =
      '';


    if (
      artwork ===
      'Artwork Still Being Developed by Our Team / Designer'
    ) {

      artworkCaveat =
        ' Production-ready artwork must also pass FABX preflight before Production Release.';

    }


    /* =====================================================
       BESPOKE
       ===================================================== */

    if (
      routeInfo.route ===
      'BESPOKE'
    ) {

      var bespokeMinimumWD =
        isComplexBespokeRoute()
          ? 30
          : 20;


      var bespokeGuide =
        isComplexBespokeRoute()
          ? BESPOKE_PLANNING_COMPLEX
          : BESPOKE_PLANNING_STANDARD;


      if (
        workingDaysToTarget <
        bespokeMinimumWD
      ) {

        return {

          status:
            'BESPOKE TIMELINE TOO SHORT',

          title:
            'The selected bulk deadline is not workable',

          copy:
            'The requested date is about ' +
            workingDaysToTarget +
            ' working days away. This brief needs Bespoke review; plan for ' +
            bespokeGuide +
            '. Development and approval happen before bulk. Choose a later date or use Sample Development Only.'

        };

      }


      return {

        status:
          'BESPOKE REVIEW — PLANNING WINDOW EXISTS',

        title:
          'Bespoke timing requires project review',

        copy:
          'The date sits outside the minimum Bespoke planning floor. Plan for ' +
          bespokeGuide +
          '. FABX will confirm the actual timeline after reviewing the brief.'

      };

    }


    /* =====================================================
       STANDARD FITS
       ===================================================== */

    var standardFullyFits =
      standardReleaseStillPossible &&
      sampleFitsBeforeStandardRelease;


    if (
      standardFullyFits
    ) {

      if (
        routeInfo.route ===
        'MANAGED CORPORATE'
      ) {

        return {

          status:
            'MANAGED REVIEW — TIMELINE MAY FIT',

          title:
            'Standard timing may fit — FABX review required',

          copy:
            'For an in-hand date of ' +
            formatYMD(
              inHand
            ) +
            ', Production Release is needed by approximately ' +
            formatDate(
              standardReleaseBy
            ) +
            '.' +
            (
              sampleStageRequired

                ?

              ' One Client Approval Sample round plus the minimum 3-working-day client approval / final-lock window must be completed before then.'

                :

              ''
            ) +
            artworkCaveat +
            releaseCutoffNote(
              standardReleaseBy
            ) +
            ' FABX must confirm capacity before this date is accepted. ' +
            earliestText

        };

      }


      if (
        sampleStageRequired
      ) {

        var extraBuffer =
          countWorkingDaysBetween(
            earliestProductionRelease,
            standardReleaseBy
          );


        return {

          status:
            'STANDARD POTENTIALLY WORKABLE — SAMPLE FIRST',

          title:
            'Standard timing may be workable — sample first',

          copy:
            'For an in-hand date of ' +
            formatYMD(
              inHand
            ) +
            ', Production Release is needed by approximately ' +
            formatDate(
              standardReleaseBy
            ) +
            '. The required Client Approval Sample and minimum 3-working-day approval / final-lock window fit before that cutoff.' +
            (
              extraBuffer > 0

                ?

              ' The current plan leaves about ' +
              extraBuffer +
              ' additional working day' +
              (
                extraBuffer === 1
                  ? ''
                  : 's'
              ) +
              ' of buffer.'

                :

              ' There is no additional buffer beyond the required approval window.'
            ) +
            artworkCaveat +
            releaseCutoffNote(
              standardReleaseBy
            ) +
            ' Capacity is not reserved. ' +
            earliestText

        };

      }


      return {

        status:
          'STANDARD POTENTIALLY WORKABLE',

        title:
          'Standard timing is potentially workable',

        copy:
          'For an in-hand date of ' +
          formatYMD(
            inHand
          ) +
          ', Production Release is needed by approximately ' +
          formatDate(
            standardReleaseBy
          ) +
          '. Standard bulk production is ' +
          STANDARD_PRODUCTION +
          '.' +
          artworkCaveat +
          (
            isRepeatStage(
              stage
            )

              ?

            ' This assumes the approved repeat configuration is unchanged.'

              :

            ''
          ) +
          releaseCutoffNote(
            standardReleaseBy
          ) +
          ' Capacity is not reserved. ' +
          earliestText

      };

    }


    /* =====================================================
       STANDARD FAILS — CHECK RUSH
       ===================================================== */

    var rushScopeEligible =
      rushScopeIsEligible();


    var rushFullyFits =
      rushScopeEligible &&
      rushReleaseStillPossible &&
      sampleFitsBeforeRushRelease;


    if (
      rushFullyFits
    ) {

      return {

        status:
          'RUSH REVIEW MAY BE POSSIBLE',

        title:
          'Standard timing is unavailable — Rush may be possible',

        copy:
          'Rush may be possible at +30% for bulk production. Rush bulk production is ' +
          RUSH_PRODUCTION +
          '. For an in-hand date of ' +
          formatYMD(
            inHand
          ) +
          ', Production Release is needed by approximately ' +
          formatDate(
            rushReleaseBy
          ) +
          '.' +
          (
            sampleStageRequired

              ?

            ' The Client Approval Sample stays on its normal planning window, followed by a minimum 3-working-day client approval / final-lock window before Production Release.'

              :

            ''
          ) +
          artworkCaveat +
          releaseCutoffNote(
            rushReleaseBy
          ) +
          ' Subject to FABX and supplier capacity. ' +
          earliestText

      };

    }


    /* =====================================================
       BLOCKED
       ===================================================== */

    var blockedRushReason =
      '';


    if (
      !FABX_RUSH_AVAILABLE
    ) {

      blockedRushReason =
        ' Rush is currently unavailable.';

    }

    else if (
      quantity > 100
    ) {

      blockedRushReason =
        ' The automatic Rush route is limited to 100 pcs.';

    }

    else if (
      designs !==
      '1 Design'
    ) {

      blockedRushReason =
        ' The automatic Rush route is limited to 1 design.';

    }

    else if (
      !rushReleaseStillPossible
    ) {

      blockedRushReason =
        ' The Rush Production Release cutoff has also passed.';

    }

    else if (
      sampleStageRequired &&
      !sampleFitsBeforeRushRelease
    ) {

      blockedRushReason =
        ' Bulk Rush does not shorten the Client Approval Sample stage or the minimum 3-working-day client approval / final-lock window, so the sample route cannot reach Production Release in time.';

    }


    if (
      standardReleaseStillPossible &&
      sampleStageRequired &&
      !sampleFitsBeforeStandardRelease
    ) {

      return {

        status:
          'TIMELINE TOO TIGHT — SAMPLE AND APPROVAL CANNOT FIT',

        title:
          'The selected bulk deadline does not leave enough time for sample approval',

        copy:
          'FABX requires one Client Approval Sample round plus a minimum 3-working-day client / end-client approval and final-lock window before Production Release.' +
          artworkCaveat +
          blockedRushReason +
          ' ' +
          earliestText +
          ' Choose a later in-hand date or use Sample Development Only. If your team does not require physical sample approval, change the sample requirement above to No and the deadline check will recalculate.'

      };

    }


    return {

      status:
        'TIMELINE NOT WORKABLE AS STANDARD',

      title:
        'The selected bulk deadline is not workable',

      copy:
        'For ' +
        formatYMD(
          inHand
        ) +
        ', Standard Production Release was needed by approximately ' +
        formatDate(
          standardReleaseBy
        ) +
        '.' +
        (
          standardReleaseStillPossible
            ? ''
            : ' That cutoff has passed.'
        ) +
        (
          sampleStageRequired

            ?

          ' One Client Approval Sample round plus the minimum 3-working-day approval / final-lock window must also be completed before Production Release.'

            :

          ''
        ) +
        artworkCaveat +
        blockedRushReason +
        ' ' +
        earliestText +
        ' Choose a later date or use Sample Development Only.'

    };

  }


  /* =========================================================
     ROUTE DISPLAY
     ========================================================= */

  function updateRouteBox(
    routeInfo
  ) {

    var box =
      el(
        'fabx-route-box'
      );


    var title =
      el(
        'fabx-route-title'
      );


    var copy =
      el(
        'fabx-route-copy'
      );


    var reasons =
      el(
        'fabx-route-reasons'
      );


    if (
      !box ||
      !title ||
      !copy ||
      !reasons
    ) {

      return;

    }


    box.className =
      'fabx-route-box';


    reasons.innerHTML =
      '';


    if (
      routeInfo.route ===
      'CATALOGUE'
    ) {

      box.classList.add(
        'fabx-route-catalogue'
      );


      title.textContent =
        'Catalogue / Shortlisting Route';


      copy.textContent =
        'This project is not yet at formal-quote stage. Start with the Corporate Catalogue.';


      btn.textContent =
        'View Corporate Catalogue';

    }


    else if (
      routeInfo.route ===
      'STANDARD'
    ) {

      box.classList.add(
        'fabx-route-standard'
      );


      title.textContent =
        'FABX Standard Route';


      copy.textContent =
        clientPhysicalSampleApprovalRequired()

          ?

        'The current selections fit an established FABX production route with a Client Approval Sample stage before bulk.'

          :

        'The current selections fit an established FABX production route. FABX may still require physical validation after review; final quotation also depends on artwork preflight and live capacity.';


      btn.textContent =
        'Request a Quote';

    }


    else if (
      routeInfo.route ===
      'MANAGED CORPORATE'
    ) {

      box.classList.add(
        'fabx-route-managed'
      );


      title.textContent =
        'Managed Corporate Review';


      copy.textContent =
        'The core product may fit FABX, but the brief requires manual review before pricing or timing can be committed.';


      btn.textContent =
        'Request Managed Corporate Review';

    }


    else {

      box.classList.add(
        'fabx-route-bespoke'
      );


      title.textContent =
        'Bespoke Project Review';


      copy.textContent =
        'The submitted brief contains requirements outside the automatic Standard route.';


      btn.textContent =
        'Request Bespoke Project Review';

    }


    routeInfo.reasons.forEach(
      function (reason) {

        var li =
          document.createElement(
            'li'
          );


        li.textContent =
          reason;


        reasons.appendChild(
          li
        );

      }
    );


    box.style.display =
      'block';


    el(
      'fabx-route'
    ).value =
      routeInfo.route;

  }


  /* =========================================================
     SAMPLE DEVELOPMENT ONLY
     ========================================================= */

  var SAMPLE_ONLY_MODE =
    'SAMPLE DEVELOPMENT ONLY';


  var submissionMode =
    'BULK / PROJECT REVIEW';


  function getSampleOnlyButton() {

    return (
      el(
        'fabx-sample-only-button'
      ) ||

      el(
        'fabx-sample-only-btn'
      ) ||

      Array.prototype.slice.call(
        document.querySelectorAll(
          'button'
        )
      ).find(
        function (button) {

          return (
            button.textContent
              .toLowerCase()
              .indexOf(
                'sample development only'
              ) !== -1
          );

        }
      )
    );

  }


  function getSampleOnlyBox() {

    var direct =
      el(
        'fabx-sample-only-box'
      );


    if (direct) {
      return direct;
    }


    var button =
      getSampleOnlyButton();


    if (!button) {
      return null;
    }


    var special =
      button.closest(
        '.fabx-sample-only-box'
      );


    if (special) {
      return special;
    }


    /*
    Fallback for the current Liquid structure.
    */
    var node =
      button.parentElement;


    while (
      node &&
      node !== form &&
      node !== projectBody
    ) {

      if (
        node.textContent &&
        node.textContent.indexOf(
          'Sample Development Only'
        ) !== -1
      ) {

        return node;

      }


      node =
        node.parentElement;

    }


    return null;

  }


  function getSubmissionModeInput() {

    var input =
      el(
        'fabx-submission-mode'
      );


    if (input) {
      return input;
    }


    input =
      document.createElement(
        'input'
      );


    input.type =
      'hidden';


    input.id =
      'fabx-submission-mode';


    input.name =
      'submission_mode';


    input.value =
      submissionMode;


    form.appendChild(
      input
    );


    return input;

  }


  function assessmentBlocksBulk(
    assessment
  ) {

    return [
      'BESPOKE TIMELINE TOO SHORT',
      'TIMELINE TOO TIGHT — SAMPLE AND APPROVAL CANNOT FIT',
      'TIMELINE NOT WORKABLE AS STANDARD'
    ].indexOf(
      assessment.status
    ) !== -1;

  }


  function resetSampleOnlyMode() {

    submissionMode =
      'BULK / PROJECT REVIEW';


    getSubmissionModeInput().value =
      submissionMode;

  }


  function selectSampleOnlyMode(
    event
  ) {

    if (event) {
      event.preventDefault();
    }


    submissionMode =
      SAMPLE_ONLY_MODE;


    getSubmissionModeInput().value =
      submissionMode;


    btn.disabled =
      false;


    btn.textContent =
      'Request Sample Development';


    var box =
      getSampleOnlyBox();


    if (box) {
      box.style.display =
        'block';
    }

  }


  function updateSampleOnlyUI(
    assessment
  ) {

    var box =
      getSampleOnlyBox();


    var button =
      getSampleOnlyButton();


    var blocked =
      assessmentBlocksBulk(
        assessment
      );


    if (!blocked) {

      resetSampleOnlyMode();


      if (box) {
        box.style.display =
          'none';
      }


      btn.disabled =
        false;


      return;

    }


    if (box) {
      box.style.display =
        'block';
    }


    if (
      submissionMode ===
      SAMPLE_ONLY_MODE
    ) {

      btn.disabled =
        false;


      btn.textContent =
        'Request Sample Development';

    }

    else {

      btn.disabled =
        true;


      btn.textContent =
        'Select a Later In-Hand Date';

    }


    if (
      button &&
      !button.dataset.fabxBound
    ) {

      button.dataset.fabxBound =
        'true';


      button.addEventListener(
        'click',
        selectSampleOnlyMode
      );

    }

  }


  /* =========================================================
     DEADLINE DISPLAY
     ========================================================= */

  function updateDeadlineBox(
    routeInfo
  ) {

    var assessment =
      assessDeadline(
        routeInfo
      );


    el(
      'fabx-deadline-status'
    ).value =
      assessment.status;


    el(
      'fabx-deadline-box'
    ).style.display =
      'block';


    el(
      'fabx-deadline-title'
    ).textContent =
      assessment.title;


    el(
      'fabx-deadline-copy'
    ).textContent =
      assessment.copy;


    updateSampleOnlyUI(
      assessment
    );


    return assessment;

  }


  function updateRouteAndDeadline() {

    var routeInfo =
      classifyRoute();


    updateRouteBox(
      routeInfo
    );


    updateDeadlineBox(
      routeInfo
    );


    return routeInfo;

  }


  /* =========================================================
     DATE VALIDATION
     ========================================================= */

  function setDateMins() {

    var minimum =
      toYMD(
        getTodaySG()
      );


    if (
      eventDateInput
    ) {

      eventDateInput.min =
        minimum;

    }


    if (
      inHandInput
    ) {

      inHandInput.dataset.min =
        minimum;

    }


    if (
      preferredDateInput
    ) {

      preferredDateInput.dataset.min =
        minimum;

    }

  }


  function validateDateOrder() {

    var fixedEvent =
      fixedEventInput.value;


    var eventDate =
      eventDateInput.value

        ?

      new Date(
        eventDateInput.value +
        'T00:00:00'
      )

        :

      null;


    var inHand =
      inHandInput.value

        ?

      new Date(
        inHandInput.value +
        'T00:00:00'
      )

        :

      null;


    var preferred =
      preferredDateInput.value

        ?

      new Date(
        preferredDateInput.value +
        'T00:00:00'
      )

        :

      null;


    var today =
      getTodaySG();


    var eventMessage =
      '';


    var inHandMessage =
      '';


    var preferredMessage =
      '';


    if (
      eventDate &&
      eventDate < today
    ) {

      eventMessage =
        'Please select a future event/use date.';

    }


    if (
      inHand &&
      inHand < today
    ) {

      inHandMessage =
        'Please select a future in-hand date.';

    }


    if (
      inHand &&
      isWeekendDate(
        inHand
      )
    ) {

      inHandMessage =
        'Please choose a Monday–Friday in-hand date.';

    }


    if (
      preferred &&
      preferred < today
    ) {

      preferredMessage =
        'Please select a future preferred-delivery date.';

    }


    if (
      preferred &&
      isWeekendDate(
        preferred
      )
    ) {

      preferredMessage =
        'Please choose a Monday–Friday preferred-delivery date.';

    }


    if (
      !inHandMessage &&
      fixedEvent ===
        'Yes' &&
      eventDate &&
      inHand &&
      inHand > eventDate
    ) {

      inHandMessage =
        'The latest in-hand date cannot be after the event/use date.';

    }


    if (
      !preferredMessage &&
      preferred &&
      inHand &&
      preferred > inHand
    ) {

      preferredMessage =
        'Preferred delivery must be on or before the latest needed in-hand date.';

    }


    setError(
      'err-event-date',
      eventMessage
    );


    setError(
      'err-inhand-date',
      inHandMessage
    );


    setError(
      'err-preferred-date',
      preferredMessage
    );


    return !(
      eventMessage ||
      inHandMessage ||
      preferredMessage
    );

  }


  /* =========================================================
     CUSTOM OPERATIONAL DATE PICKER
     ========================================================= */

  var activeOperationalDatePicker =
    null;


  function operationalDateIsUnavailable(
    date
  ) {

    if (!date) {
      return true;
    }


    var today =
      getTodaySG();


    if (
      date < today
    ) {

      return true;

    }


    if (
      isWeekendDate(
        date
      )
    ) {

      return true;

    }


    if (
      FABX_BLACKOUT_DATES.indexOf(
        toYMD(
          date
        )
      ) !== -1
    ) {

      return true;

    }


    return false;

  }


  function operationalDateDisplay(
    ymd
  ) {

    if (!ymd) {
      return 'dd/mm/yyyy';
    }


    var parts =
      ymd.split(
        '-'
      );


    if (
      parts.length !== 3
    ) {

      return 'dd/mm/yyyy';

    }


    return (
      parts[2] +
      '/' +
      parts[1] +
      '/' +
      parts[0]
    );

  }


  function monthStartForPicker(
    ymd
  ) {

    if (ymd) {

      var selected =
        new Date(
          ymd +
          'T00:00:00'
        );


      return new Date(
        selected.getFullYear(),
        selected.getMonth(),
        1
      );

    }


    var today =
      getTodaySG();


    return new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );

  }


  function closeOperationalDatePicker(
    picker
  ) {

    if (!picker) {
      return;
    }


    picker.popover.hidden =
      true;


    picker.trigger.setAttribute(
      'aria-expanded',
      'false'
    );


    if (
      activeOperationalDatePicker ===
      picker
    ) {

      activeOperationalDatePicker =
        null;

    }

  }


  function createOperationalDatePicker(
    config
  ) {

    var input =
      el(
        config.inputId
      );


    var trigger =
      el(
        config.triggerId
      );


    var display =
      el(
        config.displayId
      );


    var popover =
      el(
        config.popoverId
      );


    /*
    If the custom Liquid markup is not present,
    leave the existing input alone.
    */
    if (
      !input ||
      !trigger ||
      !display ||
      !popover
    ) {

      return null;

    }


    var picker = {

      input:
        input,

      trigger:
        trigger,

      display:
        display,

      popover:
        popover,

      errorId:
        config.errorId,

      allowClear:
        !!config.allowClear,

      viewMonth:
        monthStartForPicker(
          input.value
        )

    };


    function syncDisplay() {

      if (
        input.value
      ) {

        display.textContent =
          operationalDateDisplay(
            input.value
          );


        display.classList.remove(
          'fabx-date-placeholder'
        );

      }

      else {

        display.textContent =
          'dd/mm/yyyy';


        display.classList.add(
          'fabx-date-placeholder'
        );

      }

    }


    function selectDate(date) {

      if (
        operationalDateIsUnavailable(
          date
        )
      ) {

        return;

      }


      input.value =
        toYMD(
          date
        );


      syncDisplay();


      setError(
        picker.errorId,
        ''
      );


      closeOperationalDatePicker(
        picker
      );


      input.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );

    }


    function clearDate() {

      input.value =
        '';


      syncDisplay();


      setError(
        picker.errorId,
        ''
      );


      closeOperationalDatePicker(
        picker
      );


      input.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );

    }


    function renderCalendar() {

      popover.innerHTML =
        '';


      var year =
        picker.viewMonth.getFullYear();


      var month =
        picker.viewMonth.getMonth();


      var header =
        document.createElement(
          'div'
        );


      header.className =
        'fabx-calendar-header';


      var prev =
        document.createElement(
          'button'
        );


      prev.type =
        'button';


      prev.className =
        'fabx-calendar-nav';


      prev.setAttribute(
        'aria-label',
        'Previous month'
      );


      prev.textContent =
        '‹';


      var controls =
        document.createElement(
          'div'
        );


      controls.className =
        'fabx-calendar-controls';


      var monthSelect =
        document.createElement(
          'select'
        );


      monthSelect.className =
        'fabx-calendar-month-select';


      monthSelect.setAttribute(
        'aria-label',
        'Month'
      );


      [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ].forEach(
        function (
          monthName,
          monthIndex
        ) {

          var option =
            document.createElement(
              'option'
            );


          option.value =
            String(
              monthIndex
            );


          option.textContent =
            monthName;


          if (
            monthIndex ===
            month
          ) {

            option.selected =
              true;

          }


          monthSelect.appendChild(
            option
          );

        }
      );


      var yearSelect =
        document.createElement(
          'select'
        );


      yearSelect.className =
        'fabx-calendar-year-select';


      yearSelect.setAttribute(
        'aria-label',
        'Year'
      );


      var currentYear =
        getTodaySG().getFullYear();


      var firstYear =
        currentYear;


      var lastYear =
        currentYear + 5;


      if (
        year < firstYear
      ) {

        firstYear =
          year;

      }


      if (
        year > lastYear
      ) {

        lastYear =
          year;

      }


      for (
        var yearOption = firstYear;
        yearOption <= lastYear;
        yearOption++
      ) {

        var yearItem =
          document.createElement(
            'option'
          );


        yearItem.value =
          String(
            yearOption
          );


        yearItem.textContent =
          String(
            yearOption
          );


        if (
          yearOption ===
          year
        ) {

          yearItem.selected =
            true;

        }


        yearSelect.appendChild(
          yearItem
        );

      }


      controls.appendChild(
        monthSelect
      );


      controls.appendChild(
        yearSelect
      );


      var next =
        document.createElement(
          'button'
        );


      next.type =
        'button';


      next.className =
        'fabx-calendar-nav';


      next.setAttribute(
        'aria-label',
        'Next month'
      );


      next.textContent =
        '›';


      var currentMonthStart =
        new Date(
          getTodaySG().getFullYear(),
          getTodaySG().getMonth(),
          1
        );


      var previousMonthStart =
        new Date(
          year,
          month - 1,
          1
        );


      if (
        previousMonthStart <
        currentMonthStart
      ) {

        prev.disabled =
          true;


        prev.classList.add(
          'is-disabled'
        );

      }


      prev.addEventListener(
        'click',
        function () {

          if (
            prev.disabled
          ) {

            return;

          }


          picker.viewMonth =
            new Date(
              picker.viewMonth.getFullYear(),
              picker.viewMonth.getMonth() - 1,
              1
            );


          renderCalendar();

        }
      );


      next.addEventListener(
        'click',
        function () {

          picker.viewMonth =
            new Date(
              picker.viewMonth.getFullYear(),
              picker.viewMonth.getMonth() + 1,
              1
            );


          renderCalendar();

        }
      );


      monthSelect.addEventListener(
        'change',
        function () {

          var proposed =
            new Date(
              Number(
                yearSelect.value
              ),
              Number(
                monthSelect.value
              ),
              1
            );


          if (
            proposed <
            currentMonthStart
          ) {

            proposed =
              currentMonthStart;

          }


          picker.viewMonth =
            proposed;


          renderCalendar();

        }
      );


      yearSelect.addEventListener(
        'change',
        function () {

          var proposed =
            new Date(
              Number(
                yearSelect.value
              ),
              Number(
                monthSelect.value
              ),
              1
            );


          if (
            proposed <
            currentMonthStart
          ) {

            proposed =
              currentMonthStart;

          }


          picker.viewMonth =
            proposed;


          renderCalendar();

        }
      );


      header.appendChild(
        prev
      );


      header.appendChild(
        controls
      );


      header.appendChild(
        next
      );


      popover.appendChild(
        header
      );


      var weekdays =
        document.createElement(
          'div'
        );


      weekdays.className =
        'fabx-calendar-weekdays';


      [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun'
      ].forEach(
        function (
          label,
          index
        ) {

          var weekday =
            document.createElement(
              'div'
            );


          weekday.className =
            'fabx-calendar-weekday' +
            (
              index >= 5
                ? ' is-weekend'
                : ''
            );


          weekday.textContent =
            label;


          weekdays.appendChild(
            weekday
          );

        }
      );


      popover.appendChild(
        weekdays
      );


      var days =
        document.createElement(
          'div'
        );


      days.className =
        'fabx-calendar-days';


      var firstDay =
        new Date(
          year,
          month,
          1
        );


      var firstWeekday =
        firstDay.getDay();


      var leadingSpaces =
        firstWeekday === 0
          ? 6
          : firstWeekday - 1;


      for (
        var s = 0;
        s < leadingSpaces;
        s++
      ) {

        var spacer =
          document.createElement(
            'div'
          );


        spacer.className =
          'fabx-calendar-spacer';


        days.appendChild(
          spacer
        );

      }


      var daysInMonth =
        new Date(
          year,
          month + 1,
          0
        ).getDate();


      var todayYMD =
        toYMD(
          getTodaySG()
        );


      for (
        var dayNumber = 1;
        dayNumber <= daysInMonth;
        dayNumber++
      ) {

        (function (day) {

          var date =
            new Date(
              year,
              month,
              day
            );


          var ymd =
            toYMD(
              date
            );


          var button =
            document.createElement(
              'button'
            );


          button.type =
            'button';


          button.className =
            'fabx-calendar-day';


          button.textContent =
            String(
              day
            );


          button.setAttribute(
            'aria-label',
            date.toLocaleDateString(
              'en-GB',
              {
                weekday:
                  'long',

                day:
                  'numeric',

                month:
                  'long',

                year:
                  'numeric'
              }
            )
          );


          var weekend =
            isWeekendDate(
              date
            );


          var past =
            date <
            getTodaySG();


          var blackout =
            FABX_BLACKOUT_DATES.indexOf(
              ymd
            ) !== -1;


          if (weekend) {
            button.classList.add(
              'is-weekend'
            );
          }


          if (past) {
            button.classList.add(
              'is-past'
            );
          }


          if (blackout) {
            button.classList.add(
              'is-unavailable'
            );
          }


          if (
            ymd ===
            todayYMD
          ) {

            button.classList.add(
              'is-today'
            );

          }


          if (
            input.value ===
            ymd
          ) {

            button.classList.add(
              'is-selected'
            );


            button.setAttribute(
              'aria-current',
              'date'
            );

          }


          if (
            weekend ||
            past ||
            blackout
          ) {

            button.disabled =
              true;

          }

          else {

            button.addEventListener(
              'click',
              function () {

                selectDate(
                  date
                );

              }
            );

          }


          days.appendChild(
            button
          );

        })(
          dayNumber
        );

      }


      popover.appendChild(
        days
      );


      if (
        picker.allowClear &&
        input.value
      ) {

        var footer =
          document.createElement(
            'div'
          );


        footer.className =
          'fabx-calendar-footer';


        var clear =
          document.createElement(
            'button'
          );


        clear.type =
          'button';


        clear.className =
          'fabx-calendar-clear';


        clear.textContent =
          'Clear date';


        clear.addEventListener(
          'click',
          clearDate
        );


        footer.appendChild(
          clear
        );


        popover.appendChild(
          footer
        );

      }

    }


    function openPicker() {

      if (
        activeOperationalDatePicker &&
        activeOperationalDatePicker !==
        picker
      ) {

        closeOperationalDatePicker(
          activeOperationalDatePicker
        );

      }


      picker.viewMonth =
        monthStartForPicker(
          input.value
        );


      renderCalendar();


      popover.hidden =
        false;


      trigger.setAttribute(
        'aria-expanded',
        'true'
      );


      activeOperationalDatePicker =
        picker;

    }


    trigger.addEventListener(
      'click',
      function () {

        if (
          popover.hidden
        ) {

          openPicker();

        }

        else {

          closeOperationalDatePicker(
            picker
          );

        }

      }
    );


    input.addEventListener(
      'change',
      syncDisplay
    );


    syncDisplay();


    return picker;

  }


  document.addEventListener(
    'click',
    function (event) {

      if (
        !activeOperationalDatePicker
      ) {

        return;

      }


      var picker =
        activeOperationalDatePicker;


      var container =
        picker.trigger.closest(
          '.fabx-date-picker'
        );


      if (
        container &&
        !container.contains(
          event.target
        )
      ) {

        closeOperationalDatePicker(
          picker
        );

      }

    }
  );


  /* =========================================================
     EVENT LISTENERS
     ========================================================= */

  productInput.addEventListener(
    'change',
    function () {

      materialInput.innerHTML =
        '<option value="">Please Select</option>';


      materialInput.value =
        '';


      populateFormatOptions();


      if (
        formatInput.value
      ) {

        populateMaterialOptions();

      }


      updateConditionalFields();

    }
  );


  formatInput.addEventListener(
    'change',
    function () {

      materialInput.value =
        '';


      populateMaterialOptions();


      updateConditionalFields();

    }
  );


  [
    companyTypeInput,
    projectStageInput,
    useTypeInput,
    fixedEventInput,
    materialInput,
    qtyStatusInput,
    designsInput,
    artworkInput,
    presentationInput,
    sampleInput,
    inHandInput,
    preferredDateInput,
    eventDateInput,
    insertInput,
    el(
      'fabx-material-selected'
    )
  ].forEach(
    function (input) {

      if (!input) {
        return;
      }


      input.addEventListener(
        'change',
        function () {

          updateConditionalFields();

          validateDateOrder();

        }
      );

    }
  );


  qtyInput.addEventListener(
    'input',
    function () {

      updateInsertAvailability();

      updateRouteAndDeadline();

    }
  );


  /* =========================================================
     INITIALISE
     ========================================================= */

  setDateMins();


  createOperationalDatePicker(
    {
      inputId:
        'fabx-inhand-date',

      triggerId:
        'fabx-inhand-date-trigger',

      displayId:
        'fabx-inhand-date-display',

      popoverId:
        'fabx-inhand-date-popover',

      errorId:
        'err-inhand-date',

      allowClear:
        false
    }
  );


  createOperationalDatePicker(
    {
      inputId:
        'fabx-preferred-date',

      triggerId:
        'fabx-preferred-date-trigger',

      displayId:
        'fabx-preferred-date-display',

      popoverId:
        'fabx-preferred-date-popover',

      errorId:
        'err-preferred-date',

      allowClear:
        true
    }
  );


  populateFormatOptions();

  updateSampleRequirementNote();

  updateConditionalFields();


  /*
  Bind the Sample Development Only action if present.
  */
  var sampleOnlyButton =
    getSampleOnlyButton();


  if (
    sampleOnlyButton &&
    !sampleOnlyButton.dataset.fabxBound
  ) {

    sampleOnlyButton.dataset.fabxBound =
      'true';


    sampleOnlyButton.addEventListener(
      'click',
      selectSampleOnlyMode
    );

  }


  /* =========================================================
     FORM SUBMISSION
     ========================================================= */

  form.addEventListener(
    'submit',
    async function (event) {

      event.preventDefault();


      if (
        value(
          'fabx-website'
        ) !== ''
      ) {

        return;

      }


      var routeInfo =
        updateRouteAndDeadline();


      if (
        routeInfo.route ===
        'CATALOGUE'
      ) {

        window.location.href =
          '/pages/corporate';


        return;

      }


      /* =====================================================
         VALUES
         ===================================================== */

      var name =
        value(
          'fabx-name'
        );


      var company =
        value(
          'fabx-company'
        );


      var email =
        value(
          'fabx-email'
        );


      var phone =
        value(
          'fabx-phone'
        );


      var companyType =
        value(
          'fabx-company-type'
        );


      var endClient =
        value(
          'fabx-end-client'
        );


      var projectStage =
        value(
          'fabx-project-stage'
        );


      var useType =
        value(
          'fabx-use-type'
        );


      var fixedEvent =
        value(
          'fabx-fixed-event'
        );


      var recipient =
        value(
          'fabx-recipient'
        );


      var eventDate =
        value(
          'fabx-event-date'
        );


      var inHandDate =
        value(
          'fabx-inhand-date'
        );


      var preferredDate =
        value(
          'fabx-preferred-date'
        );


      var product =
        value(
          'fabx-product'
        );


      var format =
        value(
          'fabx-format'
        );


      var material =
        value(
          'fabx-material'
        );


      var quantity =
        value(
          'fabx-qty'
        );


      var quantityStatus =
        value(
          'fabx-qty-status'
        );


      var designs =
        value(
          'fabx-designs'
        );


      var artwork =
        value(
          'fabx-artwork'
        );


      var presentation =
        value(
          'fabx-presentation'
        );


      var customPresentation =
        value(
          'fabx-custom-presentation'
        );


      var insert =
        value(
          'fabx-insert'
        );


      var sample =
        value(
          'fabx-sample-required'
        );


      var materialSelected =
        value(
          'fabx-material-selected'
        );


      var reference =
        value(
          'fabx-reference'
        );


      var budget =
        value(
          'fabx-budget'
        );


      var details =
        value(
          'fabx-details'
        );


      /* =====================================================
         VALIDATION
         ===================================================== */

      var hasError =
        false;


      hasError =
        setError(
          'err-name',
          !name
            ? 'Name is required.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-company',
          !company
            ? 'Company / Organisation is required.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-email',

          !email

            ?

          'Work email is required.'

            :

          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
            email
          )

            ?

          'Please enter a valid email address.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-phone',
          !phone
            ? 'Contact number is required.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-company-type',
          !companyType
            ? 'Please select a company type.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-end-client',

          isIntermediary(
            companyType
          ) &&
          !endClient

            ?

          'Please provide the end client / brand, or enter “Confidential”.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-project-stage',
          !projectStage
            ? 'Please select the current project stage.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-use-type',
          !useType
            ? 'Please select the project / use type.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-fixed-event',
          !fixedEvent
            ? 'Please tell us whether this is tied to a fixed event/use date.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-recipient',

          recipientApplies(
            useType
          ) &&
          !recipient

            ?

          'Please select the recipient tier / purpose.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-event-date',

          fixedEvent ===
            'Yes' &&
          !eventDate

            ?

          'Please provide the event/use date.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-product',
          !product
            ? 'Please select a product type.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-format',
          !format
            ? 'Please select a FABX format / size.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-material',
          !material
            ? 'Please select a fabric / material direction.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-qty',

          !quantity

            ?

          'Quantity is required.'

            :

          Number(
            quantity
          ) < 1

            ?

          'Please enter a valid quantity.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-qty-status',
          !quantityStatus
            ? 'Please select the quantity status.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-designs',
          !designs
            ? 'Please select the number of designs.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-artwork',
          !artwork
            ? 'Please select artwork status.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-presentation',
          !presentation
            ? 'Please select a presentation preference.'
            : ''
        ) || hasError;


      hasError =
        setError(
          'err-custom-presentation',

          presentation ===
            'Custom / Bespoke Presentation Required' &&
          !customPresentation

            ?

          'Please describe the custom presentation requirement or provide a reference.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-insert',
          !insert
            ? 'Please select an insert preference.'
            : ''
        ) || hasError;


      if (
        Number(
          quantity
        ) > 0 &&
        Number(
          quantity
        ) < 50 &&
        insert ===
          'Custom Front Care / Event Insert — Client-Supplied Artwork'
      ) {

        hasError =
          setError(
            'err-insert',
            'Custom front care/event inserts are available from 50 pcs.'
          ) || hasError;

      }


      hasError =
        setError(
          'err-sample-required',

          !sample

            ?

          'Please tell us whether your team or end client requires its own physical sample approval before bulk.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-material-selected',

          sample ===
            'Yes' &&
          !materialSelected

            ?

          'Please tell us whether the selected fabric has already been physically reviewed / approved.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-inhand-date',

          !inHandDate

            ?

          'Please provide the latest date the goods are needed in hand.'

            :

          ''
        ) || hasError;


      hasError =
        setError(
          'err-budget',

          routeInfo.route ===
            'BESPOKE' &&
          !budget

            ?

          'Please select an estimated budget for Bespoke project review.'

            :

          ''
        ) || hasError;


      /*
      100% Silk Twill MOQ:
      20 pcs per design.
      */
      if (
        material ===
        '100% Silk Twill — Bespoke'
      ) {

        var designCount =
          designCountNumber(
            designs
          );


        if (
          designCount > 0 &&
          Number(
            quantity
          ) <
          (
            20 *
            designCount
          )
        ) {

          hasError =
            setError(
              'err-qty',

              '100% Silk Twill MOQ is 20 pcs per design. The minimum total for ' +
              designCount +
              ' design' +
              (
                designCount > 1
                  ? 's'
                  : ''
              ) +
              ' is ' +
              (
                20 *
                designCount
              ) +
              ' pcs.'
            ) || hasError;

        }

      }


      if (
        !validateDateOrder()
      ) {

        hasError =
          true;

      }


      if (hasError) {
        return;
      }


      var assessment =
        assessDeadline(
          routeInfo
        );


      /*
      Block impossible bulk submission unless the client has
      deliberately selected Sample Development Only.
      */
      if (
        assessmentBlocksBulk(
          assessment
        ) &&
        submissionMode !==
          SAMPLE_ONLY_MODE
      ) {

        updateSampleOnlyUI(
          assessment
        );


        return;

      }


      /* =====================================================
         SUBMIT STATE
         ===================================================== */

      btn.disabled =
        true;


      btn.textContent =
        'Sending...';


      el(
        'fabx-form-error'
      ).style.display =
        'none';


      /* =====================================================
         PROJECT REFERENCE
         ===================================================== */

      var projectRef =
        generateProjectRef();


      el(
        'fabx-project-ref'
      ).value =
        projectRef;


      /* =====================================================
         EMAIL VALUES
         ===================================================== */

      var endClientForEmail =
        isIntermediary(
          companyType
        )

          ?

        endClient

          :

        'Not applicable / direct client';


      var recipientForEmail =
        recipientApplies(
          useType
        )

          ?

        recipient

          :

        'Not applicable';


      var eventDateForEmail =
        eventDate

          ?

        formatYMD(
          eventDate
        )

          :

        fixedEvent;


      var inHandForEmail =
        formatYMD(
          inHandDate
        );


      var preferredForEmail =
        preferredDate

          ?

        formatYMD(
          preferredDate
        )

          :

        '(not provided)';


      var fabxSamplePolicy =
        getFabxSamplePolicyText();


      var routeForEmail =
        submissionMode ===
          SAMPLE_ONLY_MODE

          ?

        SAMPLE_ONLY_MODE

          :

        routeInfo.route;


      var bulkDeadlineStatus =
        submissionMode ===
          SAMPLE_ONLY_MODE

          ?

        'NOT ACCEPTED — sample/development stage only'

          :

        assessment.status;


      var projectDetails = [

        'SUBMISSION MODE: ' +
        submissionMode,

        'ROUTE CLASSIFICATION: ' +
        routeForEmail,

        'UNDERLYING PROJECT ROUTE: ' +
        routeInfo.route,

        'DEADLINE ASSESSMENT: ' +
        assessment.status,

        'BULK DEADLINE STATUS: ' +
        bulkDeadlineStatus,

        '',

        'Company Type: ' +
        companyType,

        'End Client / Brand: ' +
        endClientForEmail,

        'Project Stage: ' +
        projectStage,

        'Project / Use Type: ' +
        useType,

        'Fixed Event?: ' +
        fixedEvent,

        'Event / Use Date: ' +
        eventDateForEmail,

        'Recipient Tier: ' +
        recipientForEmail,

        '',

        'Product: ' +
        product,

        'FABX Format: ' +
        format,

        'Fabric / Material: ' +
        material,

        'Quantity: ' +
        quantity,

        'Quantity Status: ' +
        quantityStatus,

        'Designs: ' +
        designs,

        'Artwork Status: ' +
        artwork,

        '',

        'Presentation: ' +
        presentation,

        'Custom Presentation: ' +
        (
          customPresentation ||
          'Not applicable'
        ),

        'Insert: ' +
        insert,

        'Client / End Client Requires Its Own Physical Sample Approval?: ' +
        sample,

        'FABX Physical Sample Policy: ' +
        fabxSamplePolicy,

        'Fabric Reviewed Physically?: ' +
        (
          materialSelected ||
          'Not applicable'
        ),

        'Reference / Existing Product: ' +
        (
          reference ||
          '(not provided)'
        ),

        '',

        'Latest Needed In Hand: ' +
        inHandForEmail,

        'Preferred Delivery: ' +
        preferredForEmail,

        'Deadline Result: ' +
        assessment.title,

        'Deadline Detail: ' +
        assessment.copy,

        '',

        'Estimated Budget: ' +
        (
          budget ||
          '(not provided)'
        ),

        '',

        'ROUTE REASONS:',

        routeInfo.reasons.join(
          ' | '
        ),

        '',

        'ADDITIONAL PROJECT DETAILS:',

        details ||
        '(not provided)'

      ].join(
        '\n'
      );


      var subject =
        '[' +
        projectRef +
        '] ' +
        routeForEmail +
        ' — ' +
        company +
        ' — ' +
        product +
        ' — ' +
        quantity +
        ' pcs — In hand ' +
        inHandForEmail;


      var indicativeLeadTime =
        'Manual review required';


      if (
        submissionMode ===
        SAMPLE_ONLY_MODE
      ) {

        indicativeLeadTime =
          'Sample/development stage only. For an established Client Approval Sample, allow up to 10 working days from Sample Release to sample in-hand, followed by a minimum 3-working-day client approval / final-lock window before any bulk Production Release. The submitted bulk deadline is not accepted or reserved.';

      }

      else if (
        routeInfo.route ===
        'STANDARD'
      ) {

        indicativeLeadTime =
          STANDARD_PRODUCTION +
          ' bulk production / ' +
          STANDARD_TO_INHAND_WD +
          ' working-day planning window from Production Release to in-hand';

      }

      else if (
        routeInfo.route ===
        'BESPOKE'
      ) {

        indicativeLeadTime =
          'Bespoke planning guide: ' +
          BESPOKE_PLANNING_STANDARD +
          '; ' +
          BESPOKE_PLANNING_COMPLEX +
          ' for more involved routes. Final timing after project review.';

      }


      /* =====================================================
         EMAILJS
         ===================================================== */

      try {

        var response =
          await fetch(

            'https://api.emailjs.com/api/v1.0/email/send',

            {

              method:
                'POST',

              headers: {
                'Content-Type':
                  'application/json'
              },

              body:
                JSON.stringify({

                  service_id:
                    'service_vvey3k3',

                  template_id:
                    'template_5hb0zn6',

                  user_id:
                    'K-U0qyRPT-u57LWOc',

                  template_params: {

                    project_ref:
                      projectRef,

                    name:
                      name,

                    company_name:
                      company,

                    email:
                      email,

                    phone:
                      phone,

                    submission_mode:
                      submissionMode,

                    route_classification:
                      routeForEmail,

                    underlying_route:
                      routeInfo.route,

                    bulk_deadline_status:
                      bulkDeadlineStatus,

                    route_reasons:
                      routeInfo.reasons.join(
                        ' | '
                      ),

                    deadline_assessment:
                      assessment.status,

                    deadline_detail:
                      assessment.copy,

                    company_type:
                      companyType,

                    end_client:
                      endClientForEmail,

                    project_stage:
                      projectStage,

                    project_use_type:
                      useType,

                    fixed_event_date:
                      fixedEvent,

                    event_use_date:
                      eventDateForEmail,

                    latest_in_hand_date:
                      inHandForEmail,

                    preferred_delivery_date:
                      preferredForEmail,

                    recipient_tier:
                      recipientForEmail,

                    product_type:
                      product,

                    product_format:
                      format,

                    preferred_material:
                      material,

                    quantity:
                      quantity,

                    quantity_status:
                      quantityStatus,

                    number_of_designs:
                      designs,

                    artwork_status:
                      artwork,

                    presentation_preference:
                      presentation,

                    packaging_customisation:
                      customPresentation ||
                      'Not applicable',

                    custom_insert_preference:
                      insert,

                    physical_sample_required:
                      sample,

                    fabx_sample_gate:
                      fabxSamplePolicy,

                    material_physically_selected:
                      materialSelected ||
                      'Not applicable',

                    reference_requirement:
                      reference ||
                      '(not provided)',

                    estimated_budget:
                      budget ||
                      '(not provided)',

                    additional_project_details:
                      details ||
                      '(not provided)',

                    delivery_date:
                      preferredForEmail,

                    indicative_lead_time:
                      indicativeLeadTime,

                    project_details:
                      projectDetails,

                    title:
                      subject

                  }

                })

            }
          );


        if (
          !response.ok
        ) {

          throw new Error(
            'EmailJS error'
          );

        }


        window.dataLayer =
          window.dataLayer ||
          [];


        window.dataLayer.push({

          event:
            'corporate_form_submit',

          form_name:
            'corporate_quote_request_v20',

          form_location:
            'corporate_quote_page',

          project_ref:
            projectRef,

          submission_mode:
            submissionMode,

          route_classification:
            routeForEmail,

          deadline_assessment:
            assessment.status,

          company_type:
            companyType,

          project_stage:
            projectStage,

          client_sample_required:
            clientPhysicalSampleApprovalRequired()

        });


        el(
          'fabx-project-ref-display'
        ).textContent =
          projectRef;


        form.style.display =
          'none';


        el(
          'fabx-form-success'
        ).style.display =
          'block';

      }

      catch (error) {

        el(
          'fabx-form-error'
        ).style.display =
          'block';


        btn.disabled =
          false;


        updateRouteAndDeadline();

      }

    }
  );

})();